export default __webpack_public_path__ + "static/qloq-61a3f318b175238a4774b8011ba10717.gif";